export function lockoutModalShown(data) {
  window.analytics.track(
    'Lockout Modal Shown',
    {
      lockout_type: data.lockoutType,
      workspace_id: data.workspaceId,
      workspace_slug: data.workspaceSlug,
      current_plan: data.currentPlan
    },
    {
      context: {
        groupId: data.workspaceId
      }
    }
  )
}
